"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Popover = _interopRequireDefault(require("./Popover"));

var _excluded = ["arrow", "forceBelow", "popoverNestedRole"];

var Tooltip = function Tooltip(_ref) {
  var arrow = _ref.arrow,
      forceBelow = _ref.forceBelow,
      popoverNestedRole = _ref.popoverNestedRole,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Popover["default"], (0, _extends2["default"])({
    popoverNestedRole: "tooltip",
    forceBelow: false,
    arrow: true
  }, rest));
};

Tooltip.propTypes = {
  triggerRef: _propTypes["default"].shape({
    current: _propTypes["default"].any
  }).isRequired,
  triggerShow: _propTypes["default"].func,
  attr: _propTypes["default"].object,
  onClickout: _propTypes["default"].func,
  show: _propTypes["default"].bool,
  children: _propTypes["default"].node.isRequired,
  render: _propTypes["default"].node.isRequired,
  arrow: _propTypes["default"].bool,
  fullWidth: _propTypes["default"].bool,
  forceBelow: _propTypes["default"].bool,
  popoverNestedRole: _propTypes["default"].string.isRequired,
  alignment: _propTypes["default"].string
};
Tooltip.defaultProps = {
  arrow: true,
  show: false,
  attr: {},
  alignment: 'start',
  fullWidth: false,
  forceBelow: false,
  triggerShow: function triggerShow() {},
  onClickout: function onClickout() {}
};
var _default = Tooltip;
exports["default"] = _default;